const getLocations = () => {
  const locations = localStorage.getItem("locations")
    ? JSON.parse(localStorage.getItem("locations"))
    : null;

  return locations;
};

const InitialState = {
  locations: getLocations(),
};

const LocationsReducer = (state = InitialState, action) => {
  if (action.type === "Save_Locations") {
    const newState = {
      ...state,
      locations: action.payload,
    };
    localStorage.setItem("locations", JSON.stringify(action.payload));
    return newState;
  }

  else if (action.type === "Remove_User") {
    localStorage.removeItem("locations");
    const newState = {
      locations: null
    };
    return newState;
  }

  return state;
};

export default LocationsReducer;